import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Ivr Message Stroke
 */

export default function IvrMessageStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M8 4C8 3.72386 7.77614 3.5 7.5 3.5C7.22386 3.5 7 3.72386 7 4V12C7 12.2761 7.22386 12.5 7.5 12.5C7.77614 12.5 8 12.2761 8 12V4ZM4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5L3 10.5C3 10.7761 3.22386 11 3.5 11C3.77614 11 4 10.7761 4 10.5L4 5.5ZM1.5 7C1.77614 7 2 7.22386 2 7.5L2 8.5C2 8.77614 1.77614 9 1.5 9C1.22386 9 1 8.77614 1 8.5V7.5C1 7.22386 1.22386 7 1.5 7ZM13.5 7C13.7761 7 14 7.22386 14 7.5V8.5C14 8.77614 13.7761 9 13.5 9C13.2239 9 13 8.77614 13 8.5V7.5C13 7.22386 13.2239 7 13.5 7ZM11.5 5C11.7761 5 12 5.22386 12 5.5V10.5C12 10.7761 11.7761 11 11.5 11C11.2239 11 11 10.7761 11 10.5V5.5C11 5.22386 11.2239 5 11.5 5ZM6 6.5C6 6.22386 5.77614 6 5.5 6C5.22386 6 5 6.22386 5 6.5V9.5C5 9.77614 5.22386 10 5.5 10C5.77614 10 6 9.77614 6 9.5V6.5ZM9.5 6C9.77614 6 10 6.22386 10 6.5V9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5V6.5C9 6.22386 9.22386 6 9.5 6Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
